var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['home-page', {
    'home-page--no-title': !_vm.title
  }]},[(_vm.title)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.title && _vm.$slots['sub-title'])?_c('div',{staticClass:"sub-title"},[_vm._t("sub-title")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }